import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/index/title-sub.webp")